import { Box } from '@mui/material';
import React, { useContext } from 'react';
import { DeckContext, getEdgeColor } from '../../../context/DeckContextV3';
import { Edge, Segment } from 'src/types/shared/blocksV3';
import EDGE_WIDTH from 'src/constants/edgeWidth';
import EdgeLabel from 'src/enums/edgeLabel';
import EDGE_INDEXES from 'src/constants/edgeTypeIndexex';

const SegmentIndicator: React.FC<{
	segment: Segment;
	edge: Edge;
	index: number;
	isSelected: boolean;
}> = ({ segment, edge, index, isSelected }) => {
	const { state } = useContext(DeckContext);
	const { scaleFactor } = state;

	const getSegmentStyles = (segment: Segment, index: number) => {
		switch (edge.label) {
			case EdgeLabel.TOP:
				return {
					width: segment.length * scaleFactor,
					height: EDGE_WIDTH,
					...(edge.segments.length > 1 &&
						index < edge.segments.length - 1 && {
							borderRight: '1px solid white',
						}),
				};
			case EdgeLabel.RIGHT:
				return {
					width: EDGE_WIDTH,
					height: segment.length * scaleFactor,
					...(edge.segments.length > 1 &&
						index < edge.segments.length - 1 && {
							borderBottom: '1px solid white',
						}),
				};
			case EdgeLabel.BOTTOM:
				return {
					width: segment.length * scaleFactor,
					height: EDGE_WIDTH,
					...(edge.segments.length > 1 &&
						index < edge.segments.length - 1 && {
							borderRight: '1px solid white',
						}),
				};
			case EdgeLabel.LEFT:
				return {
					width: EDGE_WIDTH,
					height: segment.length * scaleFactor,
					...(edge.segments.length > 1 &&
						index < edge.segments.length - 1 && {
							borderBottom: '1px solid white',
						}),
				};
			default:
				return {};
		}
	};

	return (
		<Box
			key={index}
			sx={{
				backgroundColor: getEdgeColor(segment.type, isSelected),
				...getSegmentStyles(segment, index),
				transition: 'background-color 0.3s',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: EDGE_INDEXES[segment.type],
			}}
		></Box>
	);
};

export default SegmentIndicator;
